import { getAllEntitiesApply, selectManyByPredicate, UIEntitiesRef } from '@ngneat/elf-entities';
import { executionsStore } from '@store/operations/executions/executions.store';
import {
  getExecutionsDataSource,
  getLinkedExecutionsDataSource,
} from '@store/operations/executions/executions.requests';
import { select } from '@ngneat/elf';

export class ExecutionsQuery {
  store = executionsStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  filters = this.store.getValue().filters;

  executions$ = getExecutionsDataSource.data$();
  selectedExecutions$ = this.store.pipe(
    selectManyByPredicate((executionUi) => executionUi.selected, { pluck: 'id', ref: UIEntitiesRef })
  );

  linkedExecutions$ = getLinkedExecutionsDataSource.data$();

  get totalRows() {
    return this.store.getValue().pagination.total;
  }

  get selectedExecutions() {
    return this.store.query(
      getAllEntitiesApply({
        mapEntity: (e) => e.id,
        filterEntity: (e) => e.selected,
        ref: UIEntitiesRef,
      })
    );
  }
}

export const executionsQuery = new ExecutionsQuery();
